import script from "./SearchUser.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchUser.vue?vue&type=script&setup=true&lang=js"

import "./SearchUser.vue?vue&type=style&index=0&id=c36b64f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c36b64f0"]])

export default __exports__